import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import poems_static from '../assets/js/poems';

Vue.use(Vuex);

export const store = new Vuex.Store({
	state: {
		current_user: [],
		users: [],
		poems: [],
		current_poem: [],
	},
	getters: {
		fetchUser: state => state.current_user,
		fetchPoem: state => state.current_poem,
		fetchPoems: state => state.poems,
		fetchUsers: state => state.users,
	},
	mutations: {
		USER: (state, payload) => {
			state.current_user = payload;
		},
		USERS: (state, payload)=>{
			state.users = payload;
		},
		POEM: (state, payload)=>{
			state.current_poem = payload;
		},
		POEMS: (state, payload)=>{
			state.poems = payload;
		}
	},
	actions: {
		fetchUser: (context, payload) => {
      const token = window.localStorage.getItem('Bearer');
			axios({
				method: 'get',
				url: '../../api/auth',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
			})
			.then((res) => {
				context.commit("USER", res.data.current_user);
			})
			.catch(() => {
        window.localStorage.removeItem('Bearer');
        context.commit('USER', false);
			});
		},
		fetchPoems: (context, payload) => {
			axios({
				method: 'get',
				url: '../../api/poems',
				headers: {
					'Content-Type': 'application/json'
				}
			}).then((res)=>{
				context.commit("POEMS", res.data.poems)
			}).catch(() => {
				context.commit("POEMS", poems_static)
				console.log('SERVING STATIC POEMS')
			})
		}
	}
})